/**
 * Detects GIF URLs for WCAG 2.2.2 pause controls (CAT-1236).
 * Pathname only — query strings / CDN tokens are ignored.
 */
export function isAnimatedGifUrl(url: string | undefined | null): boolean {
  if (!url) return false;
  if (url.startsWith('data:image/gif')) return true;
  try {
    const pathname = new URL(url, 'https://example.invalid').pathname;
    return /\.gif$/i.test(pathname);
  } catch {
    return /\.gif(\?|#|$)/i.test(url);
  }
}
